import React, { useState } from "react";

const Header = ({ scrollToSection, activeSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleNavClick = (section) => {
    scrollToSection(section);
    closeMenu();
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <img src="/assets/vision_logo.jpeg" alt="Vision Logo" />
            <div className="logo-text">
              <h1>🌱 Vision</h1>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`mobile-menu-toggle ${isMenuOpen ? "active" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav className={`nav ${isMenuOpen ? "nav-open" : ""}`}>
            <a
              onClick={() => handleNavClick("home")}
              className={activeSection === "home" ? "active" : ""}
            >
              🏠 होम
            </a>
            <a
              onClick={() => handleNavClick("projects")}
              className={activeSection === "projects" ? "active" : ""}
            >
              🚀 परियोजनाएं
            </a>
            <a
              onClick={() => handleNavClick("about")}
              className={activeSection === "about" ? "active" : ""}
            >
              ℹ️ हमारे बारे में
            </a>
            <a
              onClick={() => handleNavClick("gallery")}
              className={activeSection === "gallery" ? "active" : ""}
            >
              📸 गैलरी
            </a>
            <a
              onClick={() => handleNavClick("awareness")}
              className={activeSection === "awareness" ? "active" : ""}
            >
              💡 जागरूकता
            </a>
            <a
              onClick={() => handleNavClick("footer")}
              className={activeSection === "footer" ? "active" : ""}
            >
              📞 संपर्क
            </a>
          </nav>

          {/* Mobile Menu Overlay */}
          {isMenuOpen && (
            <div className="mobile-menu-overlay" onClick={closeMenu}></div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
